import React, { useContext } from 'react'
import Modal from '../components/Modal'
import classes from './SwitchToAMobileDeviceModal.module.scss'
import { ModalTypes, USE_CONTENTSTACK_QUERY_TYPES } from '../store/Constants'
import { ANALYTICS } from '../store/AnalyticsConstants'
import { ConfigContext } from '../store/ConfigContext'
import { useExternalLink } from '../hooks/useExternalLink'
import useAnalytics from '../hooks/useAnalytics'
import { useAnalyticsProps } from '../hooks/useAnalyticsProps'

export const SwitchToAMobileDeviceModal = ({ open, onClose, contentType }) => {
  const { os, printer } = useContext(ConfigContext)
  const { fireHyperLinkClick } = useAnalytics(
    ANALYTICS.MODALS.SWITCH_TO_MOBILE,
    true
  )
  const { replaceContentWithExternalLink, findExternalLinkByLink } =
    useExternalLink()

  const analyticsProps = useAnalyticsProps()

  const analyticsEvent = (e) => {
    const closestAnchor = e.target.closest('a')
    if (closestAnchor && e.currentTarget.contains(closestAnchor)) {
      const analyticsLink = findExternalLinkByLink(closestAnchor.href)

      if (analyticsLink && analyticsLink.analytics_control_name) {
        fireHyperLinkClick(analyticsLink.analytics_control_name, {
          ...analyticsProps,
          detail: closestAnchor.href
        })
      }
    }
  }

  return (
    <Modal
      analytics={{
        screen: ANALYTICS.MODALS.SWITCH_TO_MOBILE,
        primary_button: ANALYTICS.BUTTONS.CLOSE_SWITCH_TO_MOBILE,
        close_button: ANALYTICS.BUTTONS.CLOSE_SWITCH_TO_MOBILE
      }}
      type={ModalTypes.switch_to_mobile}
      contentType={contentType}
      contentStackOptions={{
        queryType: USE_CONTENTSTACK_QUERY_TYPES.OPERATING_SYSTEM,
        additionalParams: {
          operatingSystem: os.toUpperCase(),
          derivativeName: printer?.derivativeName
        }
      }}
      show={open}
      className={classes.switchToAMobileDeviceModal}
      onClose={onClose}
      primaryClick={() => onClose()}
      closeButton={true}
    >
      {({ pageData }) => (
        <div
          className={classes.content}
          data-testid="switch-to-a-mobile-device-modal"
        >
          {pageData
            .filter(({ data }) => typeof data === 'string')
            .map(({ data, metadata }, i) => {
              return (
                <React.Fragment key={metadata}>
                  {i > 0 && <hr />}
                  <section
                    onClick={analyticsEvent}
                    data-testid={`switch-to-a-mobile-device-text-${i}`}
                    dangerouslySetInnerHTML={{
                      __html: replaceContentWithExternalLink(data)
                    }}
                  />
                </React.Fragment>
              )
            })}
        </div>
      )}
    </Modal>
  )
}
